import React from 'react'
import { onButtonTriggerKey } from '../../utils'

export type RatablesRatingsFilterProps = {
  handleClick: () => void
  isTaggedToBrazil: boolean
  isTaggedToLatAm: boolean
  displayLocalValues: boolean
}

export const RatablesRatingsFilter = ({
  handleClick,
  isTaggedToBrazil,
  isTaggedToLatAm,
  displayLocalValues
}: RatablesRatingsFilterProps) => {
  let displayLabel = null
  if (isTaggedToBrazil) displayLabel = 'VIEW IN PORTUGUESE (as available)'
  if (!isTaggedToBrazil && isTaggedToLatAm)
    displayLabel = 'VIEW IN SPANISH (as available)'
  if (displayLocalValues) displayLabel = 'VIEW ALL IN ENGLISH'

  return displayLabel ? (
    <>
      <div className="frw-heading--6">Ratings</div>
      <div className="frw-search__issues">
        <form
          className="frw-search__issues--form"
          name="issue__form"
          style={{ border: 'none' }}
        >
          <div className="frw-search__issues--type">
            <span
              className="frw-link--3"
              onClick={handleClick}
              onKeyDown={onButtonTriggerKey(handleClick)}
              role="button"
              tabIndex={0}
            >
              {displayLabel}
            </span>
          </div>
        </form>
      </div>
    </>
  ) : null
}
